export default __webpack_public_path__ + "static/niche-7164bad929e162c01fe23243b54c889e.webp";